import { Inject, Injectable } from '@angular/core';
import {
    ConfigConstants,
    Equipment,
    initialAddressState,
    initialNotificationStatusState,
    isDefined,
    Notification,
    NOTIFICATION_STATUS_CODE,
    NotificationInterface,
    NotificationModel,
    NotificationStatus,
} from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { initialOdataEquipmentModel } from '../../interfaces/equipments-odata.interface';

@Injectable({
    providedIn: 'root',
})
export class NotificationService implements NotificationInterface {
    private notification: Notification;
    public constructor(@Inject(LogInstanceToken) private readonly log: LogInterface) {}

    public getNotificationStateByIdentifier(): Notification | undefined {
        return this.notification;
    }

    public getStatusStateByIdentifier(): NotificationStatus {
        if (!isDefined(this.notification)) {
            throw new Error(
                `NotificationService: getStatusStateByIdentifier: Calling before dummy notification has been created`,
            );
        }
        return this.notification.updatedStatus;
    }

    public getMainEquipmentFromNotification(notification: Notification): Equipment | undefined {
        return notification.equipmentSet[0];
    }

    public getNotificationStateByEquipment(): Notification[] {
        return [];
    }

    public getNotificationByIdentifier(): NotificationModel | undefined {
        return;
    }

    public getAllSPQDocIDs(): string[] {
        return [];
    }

    public createDummyNotificationForAuthors(equipmentModel = initialOdataEquipmentModel): void {
        this.log.debug(
            `NotificationService(FI): createDummyNotificationForFI: data received as params ${JSON.stringify(
                equipmentModel,
            )}`,
        );
        const mainEquipments = equipmentModel.EquipmentsSet.results[0];
        // Creating dummy notification as there is no role of notifications in FI
        this.notification = {
            identifier: {
                frontId: equipmentModel.User,
                qmNum: mainEquipments.OrderNumber,
                // Hardcode maNum to 0001 as this is a dummy notification and nothing is related to Gateway
                maNum: '0001',
            },
            backendStatus: {
                ...initialNotificationStatusState,
            },
            // updated status should always be OSR otherwise forms won't be opened in editable mode
            updatedStatus: {
                ...initialNotificationStatusState,
                statusCode: NOTIFICATION_STATUS_CODE.OSR,
            },
            languageId: '',
            notificationType: ConfigConstants.NotificationTypes.Installation,
            address: {
                ...initialAddressState,
                name1: mainEquipments.Name1 ? mainEquipments.Name1 : mainEquipments.StName1,
                name2: mainEquipments.Name2 ? mainEquipments.Name2 : mainEquipments.StName2,
                street: mainEquipments.Street ? mainEquipments.Street : mainEquipments.StStreet,
                city: mainEquipments.Address ? mainEquipments.Address : mainEquipments.StAddress,
                department: mainEquipments.Department,
                country: mainEquipments.Country ? mainEquipments.Country : mainEquipments.HcCountry,
            },
            equipmentSet: [
                {
                    equnr: mainEquipments.EquipmentHq,
                    tidnr: '',
                    matnr: mainEquipments.PartNo,
                    sernr: mainEquipments.SerialNo,
                    equiShortDesc: mainEquipments.Description,
                    division: '',
                    mainEquipmentIndicator: '',
                },
            ],
            emailSet: [],
            functionalLocation: mainEquipments.Location,
        };
    }
}
